<div>Test BC {{title}}</div>

<div nz-row>
    <div nz-col nzSpan="8">
        <my-health-input-group
            [title]="title1"
            [options]="fields1"
            [headerStyle]="headerStyle"
            [inputColor]="inputColor"
        ></my-health-input-group>
    </div>
    <div nz-col nzSpan="8">
        <my-health-input-group
            [title]="title2"
            [options]="fields2"
            [headerStyle]="headerStyle"
            [inputColor]="inputColor"
        ></my-health-input-group>
    </div>
    <div nz-col nzSpan="8">
        <my-health-input-group
            [title]="title3"
            [options]="fields3"
            [headerStyle]="headerStyle"
            [inputColor]="inputColor"
        ></my-health-input-group>
    </div>
</div>
